//基金项目
export const fundList = [
	{
		value: '1',
		label: '国际级',
	},
	{
		value: '2',
		label: '国家级',
	},
	{
		value: '3',
		label: '省级',
	},
	{
		value: '4',
		label: '市、院、校级',
	},
	{
		value: '5',
		label: '县级及其他',
	},
]
//
export const contributionInfo = [
	// {
	// 	label:'期望刊出时间',
	// 	name:'hopePublishDate',
	// 	type:'time',
	// },
	{
		label: '责任采编',
		name: 'editingId',
		type: 'select',
		selectData: [],
		disabled: false,
	},
	{
		label: '备注',
		name: 'leaveMsg',
		type: 'textarea',
	},
]
//添加作者
export const addInfo = [
	{
		label: '作者姓名',
		name: 'userName',
		type: 'text'
	},
	{
		label: '手机/账号',
		name: 'phone',
		type: 'text',
		maxlength: 11
	},
]
//作者基本信息展示
export const authorInfo = [
	{
		label: '姓名',
		name: 'userName',
		type: 'text',
		disabled: true,

	},
	{
		label: '单位',
		name: 'unit',
		type: 'text',
	},
	// {
	// 	label:'单位地址',
	// 	name:'area',
	// 	type:'text',
	// },
	{
		label: "单位地址",
		name: "city",
		name2: "province",
		slot: 'city',
		type: "selectCity",
	},
	{
		label: '出生年份',
		name: 'birthday',
		type: "year",
	},
	{
		label: '性别',
		name: 'sex',
		type: 'radio',
		RadioGroup: ['男', '女']
	},
	{
		label: '学历/学位',
		name: 'education',
		type: 'select',
		selectData: [
			{
				id: "大学专科",
				name: "大学专科",
			  },
			  {
				id: "大学本科",
				name: "大学本科",
			  },
			  {
				id: "在职硕士",
				name: "在职硕士",
			  },
			  {
				id: "硕士在读",
				name: "硕士在读",
			  },
			  {
				id: "硕士研究生",
				name: "硕士研究生",
			  },
			  {
				id: "博士在读",
				name: "博士在读",
			  },
			  {
				id: "博士研究生",
				name: "博士研究生",
			  },
			  {
				id: "其他",
				name: "其他",
			  },
		]
	},
	{
		label: '职称',
		name: 'title',
		type: 'text',
	},
	{
		label: '研究方向',
		name: 'researchField',
		type: 'text',
	},
	{
		label: '手机',
		name: 'phone',
		type: 'text',
		disabled: true,
	},
	{
		label: '邮箱',
		name: 'email',
		type: 'text',
	},
]

//添加非系统用户
export const system = [
	{
		label: '姓名',
		name: 'nickName',
		type: 'text',
	},
	{
		label: '性别',
		name: 'sex',
		type: 'radio',
		RadioGroup: ['男', '女']

	},
	{
		label: '出生年份',
		name: 'birthday',
		type: "year",
	},
	{
		label: '学历/学位',
		name: 'education',
		type: 'select',
		selectData: [
			{
				id: "大学专科",
				name: "大学专科",
			  },
			  {
				id: "大学本科",
				name: "大学本科",
			  },
			  {
				id: "在职硕士",
				name: "在职硕士",
			  },
			  {
				id: "硕士在读",
				name: "硕士在读",
			  },
			  {
				id: "硕士研究生",
				name: "硕士研究生",
			  },
			  {
				id: "博士在读",
				name: "博士在读",
			  },
			  {
				id: "博士研究生",
				name: "博士研究生",
			  },
			  {
				id: "其他",
				name: "其他",
			  },
		]
	},
	{
		label: '工作单位',
		name: 'unit',
		type: 'text',
	},
	{
		label: '职称',
		name: 'title',
		type: 'text',
	},
	{
		label: '研究方向',
		name: 'Research',
		type: 'text',
	},
	{
		label: '手机',
		name: 'phone',
		type: 'text',
	},
	{
		label: '邮箱 ',
		name: 'email',
		type: 'text',
	},

]
//添加作者基本信息
export const addAuthorInfo = [
	{
		label: '手机',
		name: 'phone',
		type: 'text',
		maxlength: 11,
		notes: '手机号即为系统账号，为保证作者信息的安全，请填写作者的真实手机号'
	},
	{
		label: '姓名',
		name: 'nickName',
		type: 'text',
	},
	{
		label: '出生年份',
		name: 'birthday',
		type: "year",
	},
	{
		label: '性别',
		name: 'sex',
		type: 'radio',
		RadioGroup: ['男', '女']

	},

	{
		label: '学历/学位',
		name: 'education',
		type: 'select',
		selectData: [
			{
				id: "大学专科",
				name: "大学专科",
			  },
			  {
				id: "大学本科",
				name: "大学本科",
			  },
			  {
				id: "在职硕士",
				name: "在职硕士",
			  },
			  {
				id: "硕士在读",
				name: "硕士在读",
			  },
			  {
				id: "硕士研究生",
				name: "硕士研究生",
			  },
			  {
				id: "博士在读",
				name: "博士在读",
			  },
			  {
				id: "博士研究生",
				name: "博士研究生",
			  },
			  {
				id: "其他",
				name: "其他",
			  },
		]
	},
	{
		label: '工作单位',
		name: 'unit',
		type: 'text',
	},
	{
		label: "单位地址",
		name: "city",
		name2: "province",
		slot: 'city',
		type: "selectCity",
	},
	{
		label: '邮箱 ',
		name: 'email',
		type: 'text',
	},
	// {
	// 	label:'单位地址(省)',
	// 	name:'province',
	// 	type:'select',
	// 	selectData:[]
	// },
	// {
	// 	label:'单位地址(市)',
	// 	name:'city',
	// 	type:'select',
	// 	selectData:[]
	// },
]
//作者基本信息确认
export const authorInfoConfirmed = [
	// {
	// 	label: '稿件',
	// 	name: 'articlePath',
	// },
	{
		label: '稿件编号',
		name: 'articleNo',
	},
	{
		label: '文章标题',
		name: 'title',
	},
	{
		label: '作者',
		name: 'author',
		type: 'authorList',
	},
	{
		label: '摘要',
		name: 'summary',
	},
	{
		label: '关键词',
		name: 'articleKey',
	},
	{
		label: '中图分类号',
		name: 'libraryClassifyNumber',
		type: 'library',
	},
	{
		label: '基金项目',
		name: 'fund',
		type: 'fundList'
	},
	{
		label: '创新点',
		name: 'innovationPoint',

	},

	{
		label: '附件',
		name: 'annexPathName',
	},
	{
		label: '上传版权协议',
		name: 'copyrightAgreement',
		type: 'img'
	},
	{
		label: '期望刊出时间',
		name: 'hopePublishDate',
	},
	{
		label: '备注',
		name: 'leaveMsg',
	},
	{
		label: '责任采编',
		name: 'editingName',
	},
	{
		label: '费用明细',
		name: 'orderCost',
		type: 'orderCostList'
	},
	{
		label: '费用合计',
		name: 'feeSum',
	},
	{
		label: '应付金额',
		name: '',
	},
]



// WEBPACK FOOTER //
// ./src/views/manage/contributorInformation/const.js